import GatsbyImage from 'gatsby-image';
import * as React from 'react';

import { Container } from 'components/shared/container';
import { getFluidImage, getTextWithoutParagraph } from 'utils';

import WaveSvgUrl from './images/pattern-wave.url.svg';
import TriangleSvgUrl from './images/solution-trust.url.svg';
import TriangleThemePurpleSvgUrl from './images/triangles-theme-purple.url.svg';
import { LogosBlock } from './logos-block';
import {
  Wrapper,
  Inner,
  Grid,
  ContentLeft,
  ContentRight,
  StyledTitle,
  Description,
  StyledLink,
  StyledLinkArrowIcon,
  BackgroundImageWrapper,
  TriangleImg,
  TriangleThemePurpleImg,
  WaveImg,
  BottomText,
} from './trusted.styles';

export const Trusted = (props) => {
  const {
    theme,
    title,
    description,
    image,
    imageLogo,
    buttonText,
    buttonLink,
    items,
    bottomTitle,
    bottomDescription,
    bottomButtonText,
    bottomButtonLink,
    bottomText,
    hideBackgroundImage,
  } = props;

  return (
    <Wrapper>
      <Container>
        <StyledTitle
          theme={theme}
          as="h2"
          size="xl"
          dangerouslySetInnerHTML={{
            __html: getTextWithoutParagraph(title),
          }}
        />
      </Container>
      <Inner>
        <Grid theme={theme}>
          <ContentLeft>
            <Description
              theme={theme}
              dangerouslySetInnerHTML={{
                __html: getTextWithoutParagraph(description),
              }}
            />
            {bottomText && <BottomText>{bottomText}</BottomText>}
            {buttonText && (
              <StyledLink theme={theme} to={buttonLink}>
                {buttonText}
                <StyledLinkArrowIcon />
              </StyledLink>
            )}
          </ContentLeft>
          <ContentRight>
            <GatsbyImage
              style={{
                maxHeight: 510,
                height: '100%',
                width: '100%',
              }}
              imgStyle={{
                objectFit: 'cover',
                objectPosition: 'center center',
              }}
              fluid={getFluidImage(image.localFile)}
              alt={image.altText}
            />
            {imageLogo && (
              <GatsbyImage
                style={{
                  position: 'absolute',
                  maxWidth: imageLogo.localFile.childImageSharp.fluid.presentationWidth,
                  zIndex: 1,
                  width: '100%',
                }}
                fluid={getFluidImage(imageLogo.localFile)}
                alt={imageLogo.altText}
              />
            )}
          </ContentRight>
        </Grid>

        {items && (
          <LogosBlock
            items={items}
            bottomTitle={bottomTitle}
            bottomDescription={bottomDescription}
            bottomButtonText={bottomButtonText}
            bottomButtonLink={bottomButtonLink}
          />
        )}
      </Inner>
      {!hideBackgroundImage && (
        <BackgroundImageWrapper>
          {theme === 'purple' || theme === 'purple-dark' ? (
            <TriangleThemePurpleImg src={TriangleThemePurpleSvgUrl} />
          ) : (
            <TriangleImg src={TriangleSvgUrl} />
          )}
          {theme !== 'light-blue' || (theme !== 'purple' && <WaveImg src={WaveSvgUrl} />)}
        </BackgroundImageWrapper>
      )}
    </Wrapper>
  );
};
